(() => {
  'use strict';

  if (customElements.get('salabom-knowledge-contest')) return;

  const q = (topic, text, correct, wrong, fact) => ({ topic, text, correct, wrong, fact });

  const QUESTIONS = [
    q('Menštruačný cyklus', 'Ktorý deň sa počíta ako prvý deň menštruačného cyklu?', 'Prvý deň menštruačného krvácania', ['Posledný deň krvácania', 'Deň ovulácie', 'Deň pred začiatkom krvácania'], 'Cyklus sa počíta od prvého dňa krvácania jedného cyklu po prvý deň krvácania ďalšieho.'),
    q('Menštruačný cyklus', 'Aké rozpätie dĺžky cyklu sa u dospelých bežne uvádza?', 'Približne 21 až 35 dní', ['Presne 28 dní', '10 až 18 dní', '40 až 55 dní'], 'Dĺžka cyklu sa prirodzene líši; 28 dní je priemer, nie povinné pravidlo.'),
    q('Menštruácia', 'Čo tvorí menštruačnú krv?', 'Krv a tkanivo zo sliznice maternice', ['Iba neoplodnené vajíčko', 'Krv z vaječníkov', 'Iba hlien krčka maternice'], 'Pri menštruácii sa cez pošvu vylučuje krv a tkanivo z výstelky maternice.'),
    q('Ovulácia', 'Čo je ovulácia?', 'Uvoľnenie vajíčka z vaječníka', ['Začiatok menštruačného krvácania', 'Uhniezdenie embrya', 'Tvorba sliznice maternice'], 'Ovulácia je moment, keď vaječník uvoľní vajíčko.'),
    q('Ovulácia', 'Platí, že ovulácia nastáva u každej ženy vždy na 14. deň?', 'Nie, jej načasovanie sa môže meniť', ['Áno, bez výnimky', 'Iba počas menopauzy', 'Iba pri 21-dňovom cykle'], 'Štrnásty deň je zjednodušený model 28-dňového cyklu, nie univerzálne pravidlo.'),
    q('Hormóny', 'Ktorý hormón spúšťa ovuláciu prudkým vzostupom svojej hladiny?', 'Luteinizačný hormón (LH)', ['Inzulín', 'Melatonín', 'Kortizol'], 'Nárast LH spúšťa uvoľnenie vajíčka z dominantného folikulu.'),
    q('Hormóny', 'Ktorý hormón podporuje rast folikulov vo vaječníku?', 'Folikuly stimulujúci hormón (FSH)', ['Oxytocín', 'Adrenalín', 'Prolaktín'], 'FSH z hypofýzy podporuje vývoj ovariálnych folikulov.'),
    q('Hormóny', 'Ktorý hormón dominuje po ovulácii v luteálnej fáze?', 'Progesterón', ['Testosterón', 'Adrenalín', 'Tyroxín'], 'Žlté teliesko po ovulácii produkuje najmä progesterón.'),
    q('Hormóny', 'Čo je jednou z hlavných úloh estrogénu v prvej časti cyklu?', 'Podporovať rast sliznice maternice', ['Spustiť menštruáciu okamžite', 'Zastaviť činnosť vaječníkov', 'Znížiť telesnú teplotu o 3 °C'], 'Estrogén počas folikulárnej fázy pomáha obnovovať a zahusťovať endometrium.'),
    q('Cyklus', 'Ako sa volá fáza medzi ovuláciou a ďalšou menštruáciou?', 'Luteálna fáza', ['Folikulárna fáza', 'Menarché', 'Perimenopauza'], 'Luteálna fáza nasleduje po ovulácii a končí začiatkom ďalšej menštruácie.'),
    q('Cyklus', 'Ako sa volá prvá fáza ovariálneho cyklu pred ovuláciou?', 'Folikulárna fáza', ['Luteálna fáza', 'Postmenopauza', 'Implantačná fáza'], 'Vo folikulárnej fáze dozrievajú folikuly a jeden sa zvyčajne stane dominantným.'),
    q('Plodnosť', 'Čo sa zvyčajne deje s bazálnou teplotou po ovulácii?', 'Mierne stúpne', ['Klesne o 5 °C', 'Zostane vždy úplne rovnaká', 'Strieda sa každú hodinu'], 'Progesterón po ovulácii zvyčajne spôsobí malý, merateľný vzostup bazálnej teploty.'),
    q('Plodnosť', 'Ako sa často mení hlien krčka maternice pred ovuláciou?', 'Je čírejší, klzkejší a pružnejší', ['Úplne vždy zmizne', 'Zmení sa na krv', 'Je tvrdý a suchý ako koža'], 'Plodný cervikálny hlien býva číry a pružný a uľahčuje pohyb spermií.'),
    q('Plodnosť', 'Kde najčastejšie dochádza k oplodneniu vajíčka?', 'Vo vajíčkovode', ['V pošve', 'V krčku maternice', 'Vo vaječníku'], 'K oplodneniu najčastejšie dochádza vo vajíčkovode, potom sa embryo presúva do maternice.'),
    q('Plodnosť', 'Ako dlho približne zostáva vajíčko po ovulácii oplodniteľné?', 'Asi 12 až 24 hodín', ['Približne 14 dní', 'Celý mesiac', 'Iba jednu minútu'], 'Vajíčko má krátke okno oplodniteľnosti, spermie však môžu v reprodukčnom trakte prežiť dlhšie.'),
    q('Plodnosť', 'Môžu spermie v priaznivom cervikálnom hliene prežiť niekoľko dní?', 'Áno, často až približne 5 dní', ['Nie, vždy iba pár minút', 'Iba po menopauze', 'Presne 30 dní'], 'Prežívanie spermií vysvetľuje, prečo plodné okno začína už niekoľko dní pred ovuláciou.'),
    q('Menštruácia', 'Čo znamená pojem menarché?', 'Prvú menštruáciu', ['Poslednú menštruáciu', 'Bolestivú ovuláciu', 'Tehotenstvo'], 'Menarché označuje prvé menštruačné krvácanie.'),
    q('Menštruácia', 'Je menštruácia sama osebe choroba?', 'Nie, je to prirodzený telesný proces', ['Áno, vždy vyžaduje liečbu', 'Áno, ale iba po 25. roku', 'Nie, no nastáva iba raz'], 'Menštruácia je prirodzená súčasť reprodukčného cyklu, hoci ťažkosti môžu vyžadovať starostlivosť.'),
    q('Menštruačné zdravie', 'Čo môže byť následkom silného menštruačného krvácania?', 'Nedostatok železa a anémia', ['Vždy vyššia hladina železa', 'Trvalé zvýšenie estrogénu', 'Okamžitá menopauza'], 'Dlhodobé silné krvácanie môže viesť k nedostatku železa a chudokrvnosti.'),
    q('Menštruačné zdravie', 'Je bolesť, ktorá bráni bežným aktivitám, vždy niečo, čo treba iba pretrpieť?', 'Nie, je vhodné prebrať ju s lekárom', ['Áno, silná bolesť je vždy normálna', 'Áno, ale iba u tínedžeriek', 'Nie, no pomáha iba hladovanie'], 'Výrazná alebo zhoršujúca sa bolesť si zaslúži vyšetrenie; môže mať liečiteľnú príčinu.'),
    q('Menštruačné zdravie', 'Ktoré ochorenie môže spôsobovať silnú menštruačnú bolesť a bolesť mimo menštruácie?', 'Endometrióza', ['Krátkozrakosť', 'Senná nádcha', 'Zápal ďasien'], 'Pri endometrióze sa tkanivo podobné výstelke maternice nachádza mimo maternice a môže spôsobovať bolesť.'),
    q('Menštruačné zdravie', 'S čím sa často spája syndróm polycystických ovárií (PCOS)?', 'S nepravidelnou ovuláciou a cyklami', ['Vždy s pravidelným 28-dňovým cyklom', 'Iba so stratou sluchu', 'S okamžitou menopauzou'], 'PCOS môže ovplyvňovať ovuláciu, pravidelnosť cyklu aj hladiny androgénov.'),
    q('Menštruačné zdravie', 'Kedy je rozumné vyhľadať zdravotnú pomoc?', 'Pri nezvyčajne silnom krvácaní, mdlobách alebo prudkej bolesti', ['Iba po dovŕšení 50 rokov', 'Nikdy počas menštruácie', 'Až keď problém trvá desať rokov'], 'Náhla silná bolesť, veľmi silné krvácanie alebo mdloby sú dôvody na rýchlu konzultáciu.'),
    q('Menštruačné pomôcky', 'Ako najbezpečnejšie používať tampón?', 'Meniť ho pravidelne a zvoliť najnižšiu potrebnú savosť', ['Nechať ho zavedený niekoľko dní', 'Používať vždy najvyššiu savosť', 'Pred použitím ho parfumovať'], 'Dodržiavanie návodu, pravidelná výmena a primeraná savosť znižujú riziká vrátane zriedkavého TSS.'),
    q('PMS', 'Kedy sa typicky objavujú príznaky PMS?', 'V dňoch pred menštruáciou', ['Iba počas ovulácie', 'Výlučne po menopauze', 'Iba v prvý deň tehotenstva'], 'PMS zahŕňa opakujúce sa telesné alebo náladové zmeny pred menštruáciou.'),
    q('PMS', 'Ktorý z týchto prejavov môže patriť k PMS?', 'Citlivosť prsníkov', ['Zlomenina kosti', 'Strata farby očí', 'Náhla zmena krvnej skupiny'], 'Medzi telesné príznaky PMS patrí citlivosť prsníkov, nafukovanie, bolesť hlavy či únava.'),
    q('PMS', 'Ktorý náladový prejav môže patriť k PMS?', 'Podráždenosť', ['Trvalá strata pamäti', 'Zmena dominantnej ruky', 'Horúčka 40 °C každý cyklus'], 'PMS môže zahŕňať podráždenosť, úzkosť, zmeny nálady alebo horšie sústredenie.'),
    q('PMS', 'Čo najviac pomáha lekárovi rozpoznať opakujúci sa vzorec PMS?', 'Denník príznakov počas viacerých cyklov', ['Jedna náhodná spomienka', 'Meranie výšky každý deň', 'Krvná skupina partnera'], 'ACOG odporúča zapisovať a hodnotiť príznaky denne aspoň počas 2 až 3 mesiacov.'),
    q('PMS', 'Čo znamená skratka PMDD?', 'Predmenštruačná dysforická porucha', ['Počiatočný menopauzálny denný denník', 'Pravidelná metóda dĺžky dňa', 'Porucha menštruačnej dávky dopamínu'], 'PMDD je závažná forma predmenštruačných ťažkostí s výrazným dopadom na každodenný život.'),
    q('PMS', 'Čím sa PMDD od bežných miernych predmenštruačných zmien odlišuje?', 'Výrazne narúša fungovanie a kvalitu života', ['Objaví sa iba raz za život', 'Vždy spôsobí horúčku', 'Týka sa iba telesnej výšky'], 'Pri PMDD sú náladové a ďalšie príznaky natoľko silné, že zasahujú do práce, vzťahov či bežných aktivít.'),
    q('PMS', 'Môžu sa príznaky úzkosti alebo depresie prekrývať s PMS?', 'Áno', ['Nie, nikdy', 'Iba počas tehotenstva', 'Iba po 70. roku'], 'Úzkostné a depresívne poruchy patria medzi stavy, ktoré sa môžu s PMS prekrývať alebo ho napodobniť.'),
    q('PMS', 'Môžu ochorenia štítnej žľazy napodobniť niektoré príznaky PMS?', 'Áno', ['Nie, hormóny spolu nikdy nesúvisia', 'Iba u mužov', 'Iba pri ovulácii'], 'Únava či zmeny nálady môžu mať viac príčin; pri nejasnostiach je vhodné odborné posúdenie.'),
    q('PMS', 'Je nafukovanie možným príznakom PMS?', 'Áno', ['Nie, s cyklom nikdy nesúvisí', 'Iba po menopauze', 'Iba v tehotenstve'], 'Nafukovanie a pocit zadržiavania tekutín patria medzi časté telesné predmenštruačné ťažkosti.'),
    q('PMS', 'Môže sa pred menštruáciou meniť chuť do jedla?', 'Áno, chute aj apetít sa môžu meniť', ['Nie, apetít riadi iba počasie', 'Iba po 60. roku', 'Vždy úplne zmizne'], 'Zmeny apetítu a chute na jedlo sa uvádzajú medzi bežnými príznakmi PMS.'),
    q('PMS', 'Ktorý pohyb môže byť súčasťou starostlivosti pri PMS?', 'Pravidelná aeróbna aktivita, napríklad svižná chôdza', ['Iba extrémny tréning bez oddychu', 'Žiadny pohyb počas celého mesiaca', 'Cvičenie výlučne o polnoci'], 'Pravidelný pohyb môže niektorým ženám pomôcť zmierniť PMS symptómy a podporiť spánok i náladu.'),
    q('PMS', 'Ktorá skupina liekov sa bežne používa na menštruačnú bolesť a zápal?', 'Nesteroidné protizápalové lieky (NSAID)', ['Antibiotiká pri každej menštruácii', 'Lieky na alergiu ako jediná možnosť', 'Anestézia každý mesiac'], 'NSAID, napríklad ibuprofén či naproxén, tlmia tvorbu prostaglandínov; vhodnosť treba posúdiť individuálne.'),
    q('Menopauza', 'Ako sa medicínsky potvrdzuje prirodzená menopauza?', 'Po 12 mesiacoch bez menštruácie bez inej príčiny', ['Po jednom vynechanom cykle', 'Presne v deň 50. narodenín', 'Po prvom návale tepla'], 'Prirodzená menopauza sa určuje spätne po 12 po sebe idúcich mesiacoch bez menštruácie.'),
    q('Menopauza', 'V akom veku nastáva prirodzená menopauza u väčšiny žien?', 'Približne medzi 45 a 55 rokmi', ['Medzi 20 a 25 rokmi', 'Vždy presne v 40 rokoch', 'Až po 75. roku'], 'WHO uvádza, že väčšina žien prejde prirodzenou menopauzou medzi 45. a 55. rokom.'),
    q('Menopauza', 'Aký je približný priemerný vek menopauzy?', 'Okolo 51 rokov', ['Okolo 29 rokov', 'Presne 65 rokov', 'Okolo 80 rokov'], 'ACOG uvádza priemerný vek prirodzenej menopauzy približne 51 rokov.'),
    q('Perimenopauza', 'Čo znamená perimenopauza?', 'Prechodné obdobie vedúce k menopauze', ['Prvá menštruácia', 'Obdobie iba po 70. roku', 'Iný názov pre tehotenstvo'], 'Perimenopauza sa začína prvými zmenami menopauzálneho prechodu a končí rok po poslednej menštruácii.'),
    q('Perimenopauza', 'Ktorý býva častý skorý znak perimenopauzy?', 'Zmena dĺžky alebo pravidelnosti cyklu', ['Okamžitá zmena farby vlasov', 'Trvalá horúčka', 'Zmena krvnej skupiny'], 'V perimenopauze môžu byť cykly dlhšie, kratšie, vynechávať alebo sa môže meniť intenzita krvácania.'),
    q('Perimenopauza', 'Je počas perimenopauzy stále možné otehotnieť?', 'Áno', ['Nie, nikdy', 'Iba v deň návalu tepla', 'Iba po 60. roku'], 'Ovulácia môže byť nepravidelná, ale tehotenstvo je až do potvrdenej menopauzy stále možné.'),
    q('Perimenopauza', 'Môže perimenopauza trvať niekoľko rokov?', 'Áno', ['Nie, vždy presne jeden týždeň', 'Najviac 24 hodín', 'Iba jeden cyklus'], 'Menopauzálny prechod je postupný a u niektorých žien trvá viac rokov.'),
    q('Menopauza', 'Čo je hlavnou biologickou príčinou prirodzenej menopauzy?', 'Úbytok funkcie ovariálnych folikulov', ['Zastavenie činnosti žalúdka', 'Nedostatok spánku počas týždňa', 'Zmena ročného obdobia'], 'S vyčerpaním folikulov klesá funkcia vaječníkov a hladiny cirkulujúceho estrogénu.'),
    q('Menopauza', 'Ktoré hormóny tvorené vaječníkmi počas menopauzálneho prechodu výrazne klesajú?', 'Estrogén a progesterón', ['Inzulín a adrenalín', 'Melatonín a oxytocín', 'Rastový hormón a tyroxín'], 'Počas prechodu výrazne klesá produkcia estrogénu a progesterónu vo vaječníkoch.'),
    q('Menopauza', 'Je menopauza choroba?', 'Nie, je to prirodzená etapa života', ['Áno, vždy ide o infekciu', 'Áno, ale iba v zime', 'Nie, no týka sa iba mužov'], 'Menopauza nie je choroba, hoci jej symptómy môžu byť výrazné a liečiteľné.'),
    q('Menopauza', 'Ktorý z týchto prejavov je typický vazomotorický symptóm?', 'Nával tepla', ['Zlomenina prsta', 'Zápal slepého čreva', 'Krátkozrakosť'], 'Návaly tepla a nočné potenie sa označujú ako vazomotorické symptómy.'),
    q('Návaly tepla', 'Ako dlho typicky trvá jeden nával tepla?', 'Približne 1 až 5 minút', ['Celý mesiac bez prestávky', 'Menej než jednu sekundu vždy', 'Presne 24 hodín'], 'The Menopause Society uvádza, že jednotlivý nával typicky trvá približne 1 až 5 minút.'),
    q('Menopauza', 'Ktorý problém so spánkom sa môže objaviť v menopauzálnom prechode?', 'Nespavosť alebo budenie pri nočnom potení', ['Potreba spať vždy 20 hodín', 'Neschopnosť snívať', 'Zmena časového pásma tela'], 'Hormonálne zmeny a nočné potenie môžu zhoršovať zaspávanie aj kontinuitu spánku.'),
    q('Menopauza', 'Môže menopauza ovplyvniť náladu?', 'Áno, niektoré ženy zažívajú zmeny nálady, úzkosť či depresívne príznaky', ['Nie, hormóny a spánok náladu nikdy neovplyvnia', 'Iba počas jedného dňa', 'Vždy spôsobí rovnakú náladu každej žene'], 'Skúsenosť je individuálna; zmeny nálady môžu súvisieť s hormónmi, spánkom aj životnou situáciou.'),
    q('Menopauza', 'Čo sa môže diať s pošvovým tkanivom pri poklese estrogénu?', 'Môže byť tenšie a suchšie', ['Vždy sa úplne obnoví za deň', 'Zmení sa na sval', 'Nemôže sa nijako meniť'], 'Pokles estrogénu môže viesť k suchosti, podráždeniu a bolesti pri pohlavnom styku.'),
    q('Menopauza', 'Môže lokálny vaginálny estrogén pomáhať pri vaginálnej suchosti?', 'Áno, po posúdení zdravotníkom', ['Nie, lokálna liečba neexistuje', 'Iba ako antibiotikum', 'Vždy bez ohľadu na zdravotný stav'], 'Lokálny estrogén vo forme krému, tablety alebo krúžku patrí medzi možnosti liečby genitourinárnych symptómov.'),
    q('Menopauza', 'Čo sa po menopauze deje s rizikom úbytku kostnej hmoty?', 'Rastie', ['Vždy klesne na nulu', 'Nemení sa u nikoho', 'Kosti sa automaticky zdvojnásobia'], 'Pokles estrogénu urýchľuje stratu kostnej hmoty a prispieva k riziku osteoporózy.'),
    q('Menopauza', 'Ktorá kombinácia podporuje zdravie kostí?', 'Silový alebo záťažový pohyb, dostatok vápnika a vitamínu D', ['Iba dlhodobé ležanie', 'Vyhýbanie sa všetkým bielkovinám', 'Nosenie ťažkých topánok bez pohybu'], 'Kosti podporuje pravidelná záťaž, primeraná výživa a individuálne posúdenie rizika.'),
    q('Menopauza', 'Môžu sa po menopauze stále prenášať sexuálne prenosné infekcie?', 'Áno', ['Nie, po menopauze to nie je možné', 'Iba počas návalu tepla', 'Iba pri pravidelnom cykle'], 'Menopauza nechráni pred STI; bariérová ochrana môže byť naďalej dôležitá.'),
    q('Menopauza', 'Čo znamená predčasná menopauza podľa WHO?', 'Menopauza pred 40. rokom', ['Menopauza pred 60. rokom', 'Prvý nepravidelný cyklus po 30. roku', 'Každá menopauza bez návalov'], 'Menopauza pred 40. rokom môže súvisieť s genetickými, autoimunitnými či inými faktormi a vyžaduje odborné posúdenie.'),
    q('Menopauza', 'Môže menopauzu vyvolať odstránenie oboch vaječníkov?', 'Áno', ['Nie, vaječníky s menopauzou nesúvisia', 'Iba odstránenie slepého čreva', 'Iba vybratie jedného zuba'], 'Chirurgické odstránenie oboch vaječníkov vedie k náhlemu ukončeniu ich hormonálnej funkcie.'),
    q('Menopauza', 'Môžu chemoterapia alebo rádioterapia ovplyvniť funkciu vaječníkov?', 'Áno', ['Nie, nikdy', 'Iba po prirodzenej menopauze', 'Iba počas menštruácie'], 'Niektoré onkologické liečby môžu dočasne alebo trvalo utlmovať funkciu vaječníkov.'),
    q('Menopauza', 'Je skúsenosť s menopauzálnymi príznakmi u každej ženy rovnaká?', 'Nie, intenzita aj trvanie sa výrazne líšia', ['Áno, všetky majú rovnaké príznaky', 'Áno, vždy trvajú presne rok', 'Nie, lebo príznaky neexistujú'], 'Niektoré ženy majú málo ťažkostí, iné výrazné symptómy ovplyvňujúce kvalitu života.'),
    q('Menopauza', 'Je hormonálna liečba vhodná automaticky pre každú ženu?', 'Nie, prínosy a riziká sa posudzujú individuálne', ['Áno, bez ohľadu na anamnézu', 'Nie, hormonálna liečba neexistuje', 'Iba podľa výšky'], 'Výber liečby závisí od symptómov, veku, času od menopauzy, anamnézy a osobných preferencií.'),
    q('Menopauza', 'Existujú aj nehormonálne možnosti liečby návalov tepla?', 'Áno', ['Nie, žiadne', 'Iba antibiotiká', 'Iba operácia'], 'Na vazomotorické príznaky existujú hormonálne aj nehormonálne možnosti, ktoré treba prebrať so zdravotníkom.'),
    q('Menopauza', 'Treba nové alebo nezvyčajné krvácanie po menopauze konzultovať s lekárom?', 'Áno', ['Nie, je vždy bežné', 'Iba po desiatich rokoch', 'Stačí ho ignorovať'], 'Krvácanie po menopauze si vyžaduje vyšetrenie, aj keď jeho príčina nemusí byť vážna.'),
    q('Menopauza', 'Môžu byť nepravidelné cykly v perimenopauze bežné?', 'Áno, no nezvyčajné krvácanie treba konzultovať', ['Nie, cyklus musí zostať presne 28-dňový', 'Áno a nikdy ich netreba riešiť', 'Iba do 20. roku'], 'Zmeny cyklu sú počas prechodu bežné, ale silné, časté alebo neobvyklé krvácanie má posúdiť zdravotník.'),
    q('Hormóny', 'Kde sa tvorí gonadotropín uvoľňujúci hormón (GnRH)?', 'V hypotalame', ['V maternici', 'V pošve', 'V kostnej dreni'], 'Pulzy GnRH z hypotalamu riadia uvoľňovanie FSH a LH z hypofýzy.'),
    q('Hormóny', 'Kde sa tvoria hormóny FSH a LH?', 'V prednom laloku hypofýzy', ['V sliznici maternice', 'V močovom mechúre', 'V pankrease'], 'FSH a LH sú gonadotropíny produkované hypofýzou pod vplyvom GnRH.'),
    q('Cyklus', 'Čo vzniká z folikulu po uvoľnení vajíčka?', 'Žlté teliesko', ['Placenta', 'Nový vajíčkovod', 'Krčok maternice'], 'Po ovulácii sa zvyšok folikulu mení na žlté teliesko, ktoré produkuje progesterón.'),
    q('Cyklus', 'Čo sa zvyčajne stane so sliznicou maternice, ak nenastane tehotenstvo?', 'Odlúči sa počas menštruácie', ['Zmení sa na vaječník', 'Zostane navždy rovnaká', 'Presunie sa do vajíčkovodu'], 'Pokles progesterónu a estrogénu vedie k odlúčeniu funkčnej vrstvy endometria.'),
    q('Menštruačné zdravie', 'Je možné mať menštruačné krvácanie bez ovulácie?', 'Áno, anovulačné krvácanie je možné', ['Nie, nikdy', 'Iba po odstránení maternice', 'Iba počas tehotenstva'], 'Nie každé krvácanie znamená, že v danom cykle prebehla ovulácia.'),
    q('Plodnosť', 'Dokáže samotná kalendárová aplikácia s istotou potvrdiť ovuláciu?', 'Nie, iba ju odhaduje', ['Áno, vždy na sekundu presne', 'Áno, aj bez údajov', 'Iba po menopauze'], 'Kalendár vychádza z predchádzajúcich cyklov; skutočné načasovanie ovulácie sa môže posunúť.'),
    q('Zdravie', 'Nahrádza tento vedomostný kvíz vyšetrenie alebo lekársku radu?', 'Nie', ['Áno, úplne', 'Iba pri PMS', 'Iba po menopauze'], 'Vzdelávacie informácie pomáhajú orientácii, ale diagnózu a liečbu má riešiť kvalifikovaný zdravotník.'),
    q('Výskum rastlín', 'Ktorá rastlina sa v klinických štúdiách skúmala pre možné zmiernenie psychických aj telesných príznakov PMS?', 'Šafran', ['Petržlen', 'Rozmarín', 'Pažítka'], 'Klinické štúdie ukázali, že šafran môže podporiť zmiernenie psychických aj telesných prejavov PMS.'),
    q('Výskum PMS', 'Pri ktorej rastline dosiahlo v malej klinickej štúdii výrazné zlepšenie PMS 76 % účastníčok oproti 8 % pri placebe?', 'Šafran', ['Kôpor', 'Bazalka', 'Mäta'], 'V klinickej štúdii zaznamenalo najmenej 50-percentné zlepšenie príznakov 76 % žien užívajúcich šafran oproti 8 % žien užívajúcich placebo.'),
    q('Ženská pohoda', 'Ktorá rastlina sa skúmala pri podráždenosti, napätí a zhoršenej nálade spojenej s PMS?', 'Šafran', ['Majorán', 'Petržlen', 'Pažítka'], 'Šafran podporoval zlepšenie emočných prejavov PMS, ako sú podráždenosť, napätie, úzkosť a zhoršená nálada.'),
    q('Výskum PMDD', 'Ktorá rastlina dosiahla v klinickej štúdii lepšie hodnotenie príznakov PMDD než placebo?', 'Šafran', ['Koriander', 'Rozmarín', 'Estragón'], 'V štúdii so 120 ženami dosiahol šafran lepší výsledok než placebo v hodnotení príznakov PMDD, závažnejšej formy predmenštruačných ťažkostí.'),
    q('Perimenopauza', 'Ktorá rastlina sa v 12-týždňovej štúdii spájala so zlepšením psychických príznakov počas perimenopauzy?', 'Šafran', ['Pažítka', 'Kôpor', 'Petržlen'], 'Počas 12-týždňovej štúdie sa šafran spájal so zlepšením psychickej pohody, úzkostných príznakov a depresívneho prežívania v perimenopauze.'),
    q('Bioaktívne látky', 'Ktorá rastlina obsahuje bioaktívne látky nazývané crocíny a safranal?', 'Šafran', ['Bazalka', 'Mäta', 'Medovka'], 'Crocíny a safranal patria medzi najznámejšie bioaktívne látky šafranu. Spájajú sa s podporou nálady, zvládaním stresu a antioxidačným pôsobením.'),
    q('Nálada', 'Ktorá rastlina môže podľa výskumov ovplyvňovať dráhy súvisiace so serotonínom a reguláciou nálady?', 'Šafran', ['Petržlen', 'Pažítka', 'Kôpor'], 'Šafran môže podporovať serotonínové dráhy, ktoré zohrávajú dôležitú úlohu pri regulácii nálady a emočnej rovnováhy.'),
    q('Stres', 'Ktorá rastlina sa skúmala pre možnú podporu nálady a zvládania psychického stresu?', 'Šafran', ['Majorán', 'Koriander', 'Petržlen'], 'Klinické výskumy spájajú užívanie šafranového extraktu s podporou dobrej nálady, psychickej pohody a vyrovnanejšej reakcie na stres.'),
    q('Ochrana buniek', 'Metabolity ktorej rastliny sa v laboratórnom výskume spájali s ochranou nervových buniek pred oxidačným stresom?', 'Šafran', ['Rozmarín', 'Pažítka', 'Kôpor'], 'Metabolity šafranu podporovali ochranu nervových buniek pred oxidačným stresom a pomáhali zachovávať ich prirodzenú aktivitu.'),
    q('Výskum PMS', 'Ktorá rastlina sa skúmala počas dvoch menštruačných cyklov ako možná podpora pri PMS?', 'Šafran', ['Bazalka', 'Mäta', 'Petržlen'], 'Vo viacerých klinických štúdiách sa užívanie šafranového extraktu počas dvoch menštruačných cyklov spájalo so zmiernením príznakov PMS.')
  ];

  const NAMES = ['Nina', 'Laura', 'Tamara', 'Zuzana', 'Ema', 'Lucia', 'Simona', 'Viktória', 'Petra', 'Natália', 'Michaela', 'Lenka', 'Andrea', 'Kristína', 'Veronika'];
  const ROUND_NAMES = ['Osemfinále', 'Štvrťfinále', 'Semifinále', 'Finále'];
  const PLACEMENTS = [9, 5, 3, 2];
  const LETTERS = ['A', 'B', 'C', 'D'];

  const shuffle = (items) => {
    const copy = [...items];
    for (let index = copy.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(Math.random() * (index + 1));
      [copy[index], copy[swapIndex]] = [copy[swapIndex], copy[index]];
    }
    return copy;
  };

  class SalabomKnowledgeContest extends HTMLElement {
    constructor() {
      super();
      this.debug = new URLSearchParams(window.location.search).get('contest_debug') === '1';
      this.delays = this.debug
        ? { lobby: 40, countdown: 120, question: 1200, reveal: 120, round: 180 }
        : { lobby: 360, countdown: 1000, question: 20000, reveal: 2800, round: 2200 };
      this.timers = [];
      this.cacheElements();
      this.onSubmit = this.joinContest.bind(this);
      this.onRestart = this.resetGame.bind(this);
      this.onNextQuestion = this.advanceFromReveal.bind(this);
      this.onContinueRound = this.advanceAfterRound.bind(this);
    }

    connectedCallback() {
      this.unlocked = new URLSearchParams(window.location.search).get('sr_contest_unlocked') === '1' || localStorage.getItem('sr__feature_unlocked__knowledge_contest') === '1';
      this.joinForm.addEventListener('submit', this.onSubmit);
      this.restartButton.addEventListener('click', this.onRestart);
      this.nextQuestionButton.addEventListener('click', this.onNextQuestion);
      this.continueRoundButton.addEventListener('click', this.onContinueRound);
      this.resetState();
      if (this.unlocked) {
        const savedName = localStorage.getItem('sr__knowledge_contest__name');
        if (savedName) this.startWithName(savedName);
      }
    }

    disconnectedCallback() {
      this.clearTimers();
      this.joinForm.removeEventListener('submit', this.onSubmit);
      this.restartButton.removeEventListener('click', this.onRestart);
      this.nextQuestionButton.removeEventListener('click', this.onNextQuestion);
      this.continueRoundButton.removeEventListener('click', this.onContinueRound);
    }

    cacheElements() {
      this.screens = [...this.querySelectorAll('[data-screen]')];
      this.joinForm = this.querySelector('[data-join-form]');
      this.nameInput = this.querySelector('[data-name-input]');
      this.nameError = this.querySelector('[data-name-error]');
      this.restartButton = this.querySelector('[data-restart]');
      this.nextQuestionButton = this.querySelector('[data-next-question]');
      this.continueRoundButton = this.querySelector('[data-continue-round]');
      this.liveStatus = this.querySelector('[data-live-status]');
    }

    resetState() {
      this.clearTimers();
      this.playerName = '';
      this.round = 0;
      this.questionInRound = 0;
      this.totalCorrect = 0;
      this.totalAnswered = 0;
      this.roundPlayerScore = 0;
      this.roundOpponentScore = 0;
      this.playerRoundTime = 0;
      this.opponentRoundTime = 0;
      this.selectedIndex = null;
      this.usedQuestions = shuffle(QUESTIONS);
      this.isSuddenDeath = false;
      this.suddenDeathQuestion = 0;
      this.tieBreakQuestionCursor = 20;
      this.suddenDeathResolved = false;
      this.roundAction = null;
      this.players = [];
      this.currentOpponent = null;
      this.showScreen('intro');
    }

    clearTimers() {
      this.timers.forEach((timer) => {
        window.clearTimeout(timer);
        window.clearInterval(timer);
      });
      this.timers = [];
    }

    later(callback, delay) {
      const timer = window.setTimeout(callback, delay);
      this.timers.push(timer);
      return timer;
    }

    showScreen(name) {
      this.screens.forEach((screen) => { screen.hidden = screen.dataset.screen !== name; });
      const active = this.querySelector(`[data-screen="${name}"]`);
      const heading = active && active.querySelector('h1, h2');
      if (heading) this.later(() => heading.focus({ preventScroll: true }), 30);
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    joinContest(event) {
      const name = this.nameInput.value.trim().replace(/\s+/g, ' ');
      if (!name) {
        event.preventDefault();
        this.nameError.hidden = false;
        this.nameInput.focus();
        return;
      }
      if (!this.unlocked) {
        localStorage.setItem('sr__knowledge_contest__name', name.slice(0, 24));
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'salabom_feature_email_submit', feature_id: 'knowledge_contest', marketing_consent: true, page_path: window.location.pathname });
        return;
      }
      event.preventDefault();
      this.startWithName(name);
    }

    startWithName(name) {
      this.nameError.hidden = true;
      this.playerName = name.slice(0, 24);
      localStorage.setItem('sr__feature_unlocked__knowledge_contest', '1');
      let history = {};
      try { history = JSON.parse(localStorage.getItem('sr__feature_history')) || {}; } catch (_error) { history = {}; }
      history.knowledge_contest = { title: 'Vedomostná aréna', result: 'joined', updatedAt: new Date().toISOString() };
      localStorage.setItem('sr__feature_history', JSON.stringify(history));
      const opponents = shuffle(NAMES).map((entry, index) => ({ id: `bot-${index}`, name: entry, alive: true, isUser: false }));
      const userIndex = Math.floor(Math.random() * 16);
      opponents.splice(userIndex, 0, { id: 'user', name: this.playerName, alive: true, isUser: true });
      this.players = opponents.slice(0, 16);
      this.showLobby();
    }

    showLobby() {
      this.showScreen('lobby');
      const count = this.querySelector('[data-lobby-count]');
      const progress = this.querySelector('[data-lobby-progress]');
      const title = this.querySelector('[data-lobby-title]');
      const status = this.querySelector('[data-lobby-status]');
      let joined = 1;
      count.textContent = joined;
      progress.style.width = `${(joined / 16) * 100}%`;
      const interval = window.setInterval(() => {
        joined += Math.random() > .72 ? 2 : 1;
        joined = Math.min(joined, 16);
        count.textContent = joined;
        progress.style.width = `${(joined / 16) * 100}%`;
        status.textContent = joined < 16 ? `${this.players[joined - 1].name} sa práve pripojila.` : 'Všetky miesta sú obsadené.';
        if (joined === 16) {
          window.clearInterval(interval);
          title.textContent = 'Aréna je plná!';
          this.liveStatus.textContent = 'Pripojilo sa 16 zo 16 hráčok.';
          this.later(() => this.showBracket(true), this.debug ? 80 : 900);
        }
      }, this.delays.lobby);
      this.timers.push(interval);
    }

    getAlivePlayers() { return this.players.filter((player) => player.alive); }

    playerCountLabel(count) {
      if (count === 1) return '1 hráčka';
      if (count >= 2 && count <= 4) return `${count} hráčky`;
      return `${count} hráčok`;
    }

    pickOpponent() {
      const aliveOpponents = this.getAlivePlayers().filter((player) => !player.isUser);
      return aliveOpponents[Math.floor(Math.random() * aliveOpponents.length)];
    }

    renderBracket() {
      const bracket = this.querySelector('[data-bracket]');
      const alivePlayers = this.getAlivePlayers();
      const user = alivePlayers.find((player) => player.isUser);
      const remaining = alivePlayers.filter((player) => !player.isUser && player.id !== this.currentOpponent.id);
      const matchups = [[user, this.currentOpponent]];
      for (let index = 0; index < remaining.length; index += 2) {
        matchups.push([remaining[index], remaining[index + 1]]);
      }

      const playerSlot = (player) => `
        <div class="salabom-contest__player-slot${player.isUser ? ' is-user' : ''}">
          <span class="salabom-contest__avatar" aria-hidden="true">${player.name.charAt(0).toUpperCase()}</span>
          <span class="salabom-contest__player-name">${this.escapeHtml(player.name)}${player.isUser ? ' (ty)' : ''}</span>
        </div>`;
      const matchup = (players) => `
        <div class="salabom-contest__matchup${players.some((player) => player.isUser) ? ' is-user-match' : ''}" aria-label="${this.escapeHtml(players[0].name)} proti ${this.escapeHtml(players[1].name)}">
          ${playerSlot(players[0])}
          <span class="salabom-contest__matchup-vs" aria-hidden="true">vs</span>
          ${playerSlot(players[1])}
        </div>`;
      const center = `
        <div class="salabom-contest__bracket-center" aria-hidden="true">
          <div class="salabom-contest__trophy">♛</div>
          <strong>${this.playerCountLabel(alivePlayers.length)}</strong>
          <span>v hre</span>
        </div>`;

      if (matchups.length === 1) {
        bracket.classList.add('is-final');
        bracket.innerHTML = `
          <div class="salabom-contest__bracket-final">
            <h3>Finálový duel</h3>
            ${matchup(matchups[0])}
          </div>
          ${center}`;
        return;
      }

      bracket.classList.remove('is-final');
      const splitAt = Math.ceil(matchups.length / 2);
      const side = (sideMatchups, sideName, modifier) => `
        <div class="salabom-contest__bracket-side salabom-contest__bracket-side--${modifier}">
          <h3>${sideName}</h3>
          <div class="salabom-contest__matchups">
            ${sideMatchups.map((players) => matchup(players)).join('')}
          </div>
        </div>`;
      bracket.innerHTML = `
        ${side(matchups.slice(0, splitAt), 'Ľavá vetva', 'left')}
        ${center}
        ${side(matchups.slice(splitAt), 'Pravá vetva', 'right')}`;
    }

    showBracket(firstRound = false) {
      this.currentOpponent = this.pickOpponent();
      this.querySelector('[data-bracket-title]').textContent = ROUND_NAMES[this.round];
      const playerCount = this.getAlivePlayers().length;
      const remainVerb = playerCount >= 2 && playerCount <= 4 ? 'Ostávajú' : 'Ostáva';
      this.querySelector('[data-bracket-message]').textContent = firstRound
        ? 'Našlo sa 16 hráčok. Priprav sa na prvý duel.'
        : `${remainVerb} ${this.playerCountLabel(playerCount)}. Tvojou súperkou je ${this.currentOpponent.name}.`;
      this.renderBracket();
      this.showScreen('bracket');
      this.later(() => this.startRoundCountdown(), this.debug ? 80 : 1800);
    }

    startRoundCountdown() {
      const badge = this.querySelector('[data-round-countdown]');
      const value = badge.querySelector('strong');
      let count = 3;
      badge.hidden = false;
      value.textContent = count;
      this.liveStatus.textContent = `Kolo sa začne o ${count}.`;
      const interval = window.setInterval(() => {
        count -= 1;
        if (count > 0) {
          value.textContent = count;
          this.liveStatus.textContent = `${count}`;
          return;
        }
        window.clearInterval(interval);
        badge.hidden = true;
        this.beginRound();
      }, this.delays.countdown);
      this.timers.push(interval);
    }

    beginRound() {
      this.isSuddenDeath = false;
      this.questionInRound = 0;
      this.roundPlayerScore = 0;
      this.roundOpponentScore = 0;
      this.playerRoundTime = 0;
      this.opponentRoundTime = 0;
      this.showQuestion();
    }

    showQuestion(questionOverride = null) {
      const question = questionOverride || this.usedQuestions[(this.round * 5) + this.questionInRound];
      this.currentQuestion = question;
      this.selectedIndex = null;
      this.questionTimerActive = true;
      this.questionResolved = false;
      this.questionStartedAt = Date.now();
      this.playerAnswerTime = null;
      this.opponentAnswerTime = null;
      this.opponentWaitTimer = null;
      this.querySelector('[data-round-label]').textContent = this.isSuddenDeath
        ? `${ROUND_NAMES[this.round]} · Rýchla smrť`
        : ROUND_NAMES[this.round];
      this.updateLiveScoreboard();
      this.querySelector('[data-question-number]').textContent = this.isSuddenDeath
        ? `ROZSTREL ${String(this.suddenDeathQuestion + 1).padStart(2, '0')}`
        : `${String(this.questionInRound + 1).padStart(2, '0')} / 05`;
      this.querySelector('[data-topic]').textContent = question.topic;
      this.querySelector('[data-question-text]').textContent = question.text;
      const answerStatus = this.querySelector('[data-answer-status]');
      answerStatus.classList.remove('is-waiting');
      answerStatus.textContent = 'Vyber jednu odpoveď.';
      const timerElement = this.querySelector('[data-timer]');
      timerElement.classList.remove('is-urgent');
      timerElement.style.setProperty('--timer-progress', 1);
      timerElement.setAttribute('aria-label', 'Zostáva 20 sekúnd');
      this.querySelector('[data-timer-value]').textContent = '20';

      this.currentOptions = shuffle([
        { label: question.correct, correct: true },
        ...question.wrong.map((label) => ({ label, correct: false }))
      ]);
      const answers = this.querySelector('[data-answers]');
      answers.innerHTML = '';
      this.currentOptions.forEach((option, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'salabom-contest__answer';
        button.innerHTML = `<span class="salabom-contest__answer-key">${LETTERS[index]}</span><span>${this.escapeHtml(option.label)}</span>`;
        button.addEventListener('click', () => this.selectAnswer(index));
        answers.appendChild(button);
      });
      this.showScreen('question');
      this.startQuestionTimer();
    }

    selectAnswer(index) {
      if (!this.questionTimerActive || this.selectedIndex !== null || this.questionResolved) return;
      if (this.playerAnswerTime === null) {
        this.playerAnswerTime = Math.max(0, Date.now() - this.questionStartedAt);
      }
      this.selectedIndex = index;
      [...this.querySelectorAll('.salabom-contest__answer')].forEach((button, buttonIndex) => {
        button.classList.toggle('is-selected', buttonIndex === index);
        button.setAttribute('aria-pressed', buttonIndex === index ? 'true' : 'false');
        button.disabled = true;
      });

      const playerAnsweredFirst = Math.random() < .5;
      if (!playerAnsweredFirst) {
        const lead = (this.debug ? 40 : 300) + Math.random() * (this.debug ? 100 : 2200);
        this.opponentAnswerTime = Math.max(0, this.playerAnswerTime - lead);
        this.finishQuestion();
        return;
      }

      const remaining = Math.max(0, this.delays.question - this.playerAnswerTime);
      const minimumWait = this.debug ? 60 : 1000;
      const maximumWait = Math.min(this.debug ? 240 : 4000, remaining);
      if (maximumWait < minimumWait) {
        this.opponentAnswerTime = this.playerAnswerTime;
        this.finishQuestion();
        return;
      }

      const waitTime = minimumWait + Math.random() * (maximumWait - minimumWait);
      this.opponentAnswerTime = this.playerAnswerTime + waitTime;
      const answerStatus = this.querySelector('[data-answer-status]');
      answerStatus.classList.add('is-waiting');
      answerStatus.textContent = `Čakáme na odpoveď: ${this.currentOpponent.name}…`;
      this.liveStatus.textContent = `Tvoja odpoveď je uložená. Čakáme na odpoveď hráčky ${this.currentOpponent.name}.`;
      this.opponentWaitTimer = window.setTimeout(() => this.finishQuestion(), waitTime);
      this.timers.push(this.opponentWaitTimer);
    }

    startQuestionTimer() {
      this.questionTimerActive = true;
      this.questionStartedAt = Date.now();
      const timerElement = this.querySelector('[data-timer]');
      const timerValue = this.querySelector('[data-timer-value]');
      const duration = this.delays.question;
      const started = Date.now();
      timerElement.classList.remove('is-urgent');
      timerElement.style.setProperty('--timer-progress', 1);
      timerValue.textContent = '20';
      this.questionTimerInterval = window.setInterval(() => {
        const elapsed = Date.now() - started;
        const ratio = Math.max(0, 1 - (elapsed / duration));
        const seconds = Math.max(0, Math.ceil(ratio * 20));
        timerElement.style.setProperty('--timer-progress', ratio);
        timerValue.textContent = seconds;
        timerElement.setAttribute('aria-label', `Zostáva ${seconds} sekúnd`);
        timerElement.classList.toggle('is-urgent', seconds <= 3);
        if (elapsed >= duration) {
          window.clearInterval(this.questionTimerInterval);
          this.endQuestionTimer();
        }
      }, this.debug ? 20 : 100);
      this.timers.push(this.questionTimerInterval);
    }

    endQuestionTimer() {
      if (this.questionResolved) return;
      this.questionTimerActive = false;
      this.querySelectorAll('.salabom-contest__answer').forEach((button) => { button.disabled = true; });
      this.liveStatus.textContent = 'Čas vypršal. Zobrazuje sa vyhodnotenie.';
      this.finishQuestion();
    }

    finishQuestion() {
      if (this.questionResolved) return;
      this.questionResolved = true;
      this.questionTimerActive = false;
      window.clearInterval(this.questionTimerInterval);
      window.clearTimeout(this.opponentWaitTimer);
      const responseTime = this.playerAnswerTime === null ? this.delays.question : this.playerAnswerTime;
      this.playerRoundTime += responseTime;
      const playerCorrect = this.selectedIndex !== null && this.currentOptions[this.selectedIndex].correct;
      if (playerCorrect) {
        this.totalCorrect += 1;
        if (!this.isSuddenDeath) this.roundPlayerScore += 1;
      }
      this.totalAnswered += 1;

      const botAccuracy = [.48, .57, .66, .74][this.round];
      let opponentCorrect = Math.random() < botAccuracy;
      if (this.isSuddenDeath && this.suddenDeathQuestion >= 9) opponentCorrect = !playerCorrect;
      const correctIndex = this.currentOptions.findIndex((option) => option.correct);
      const wrongIndices = this.currentOptions.map((_, index) => index).filter((index) => index !== correctIndex);
      const opponentIndex = opponentCorrect ? correctIndex : wrongIndices[Math.floor(Math.random() * wrongIndices.length)];
      if (opponentCorrect && !this.isSuddenDeath) this.roundOpponentScore += 1;
      const fallbackOpponentTime = Math.random() * this.delays.question;
      const opponentResponseTime = this.opponentAnswerTime === null ? fallbackOpponentTime : this.opponentAnswerTime;
      this.opponentRoundTime += opponentResponseTime;
      if (this.isSuddenDeath) this.resolveSuddenDeath(playerCorrect, opponentCorrect, responseTime, opponentResponseTime);
      this.updateLiveScoreboard();
      this.showReveal(playerCorrect, opponentCorrect, opponentIndex);
    }

    updateLiveScoreboard() {
      this.querySelectorAll('[data-live-player-name]').forEach((element) => { element.textContent = this.playerName; });
      this.querySelectorAll('[data-live-opponent-name]').forEach((element) => { element.textContent = this.currentOpponent.name; });
      this.querySelectorAll('[data-live-player-score]').forEach((element) => { element.textContent = this.roundPlayerScore; });
      this.querySelectorAll('[data-live-opponent-score]').forEach((element) => { element.textContent = this.roundOpponentScore; });
    }

    resolveSuddenDeath(playerCorrect, opponentCorrect, playerTime, opponentTime) {
      this.suddenDeathResolved = false;
      if (playerCorrect && opponentCorrect) return;

      this.suddenDeathResolved = true;
      if (playerCorrect !== opponentCorrect) {
        this.roundWon = playerCorrect;
        return;
      }

      // Obe odpovede sú nesprávne: vypadáva tá, ktorá sa pomýlila ako prvá.
      this.roundWon = playerTime > opponentTime;
    }

    showReveal(playerCorrect, opponentCorrect, opponentIndex) {
      const playerCard = this.querySelector('[data-player-result-card]');
      const opponentCard = this.querySelector('[data-opponent-result-card]');
      playerCard.className = playerCorrect ? 'is-correct' : 'is-wrong';
      opponentCard.className = opponentCorrect ? 'is-correct' : 'is-wrong';
      this.querySelector('[data-reveal-title]').textContent = this.currentQuestion.correct;
      this.querySelector('[data-reveal-player-name]').textContent = `${this.playerName} odpovedala`;
      this.querySelector('[data-player-answer]').textContent = this.selectedIndex === null ? 'Bez odpovede' : this.currentOptions[this.selectedIndex].label;
      this.querySelector('[data-player-verdict]').textContent = playerCorrect ? '✓ Správne' : '× Nesprávne';
      this.querySelector('[data-reveal-opponent-name]').textContent = `${this.currentOpponent.name} odpovedala`;
      this.querySelector('[data-opponent-answer]').textContent = this.currentOptions[opponentIndex].label;
      this.querySelector('[data-opponent-verdict]').textContent = opponentCorrect ? '✓ Správne' : '× Nesprávne';
      this.querySelector('[data-explanation]').textContent = this.currentQuestion.fact;
      if (this.isSuddenDeath) {
        this.querySelector('[data-next-question-label]').textContent = this.suddenDeathResolved
          ? 'Zobraziť výsledok rozstrelu'
          : 'Ďalšia rozstrelová otázka';
      } else {
        this.querySelector('[data-next-question-label]').textContent = this.questionInRound < 4 ? 'Ďalšia otázka' : 'Zobraziť výsledok kola';
      }
      this.showScreen('reveal');
    }

    advanceFromReveal() {
      if (this.isSuddenDeath) {
        if (this.suddenDeathResolved) {
          this.showSuddenDeathResult();
          return;
        }
        this.suddenDeathQuestion += 1;
        this.tieBreakQuestionCursor += 1;
        this.showQuestion(this.usedQuestions[this.tieBreakQuestionCursor]);
        return;
      }

      this.questionInRound += 1;
      if (this.questionInRound < 5) this.showQuestion();
      else this.finishRound();
    }

    finishRound() {
      if (this.roundPlayerScore === this.roundOpponentScore) {
        this.showSuddenDeathIntro();
        return;
      }
      const won = this.roundPlayerScore > this.roundOpponentScore;
      const copy = won
        ? (this.round === 3
          ? 'Vyhrala si finále a celý turnaj.'
          : `Zvládla si ${ROUND_NAMES[this.round].toLowerCase()} a pokračuješ ďalej.`)
        : `${this.currentOpponent.name} získala v tomto kole viac bodov.`;
      this.showRoundResult(won, copy);
    }

    showSuddenDeathIntro() {
      this.isSuddenDeath = true;
      this.suddenDeathQuestion = 0;
      this.suddenDeathResolved = false;
      this.roundAction = 'start-sudden-death';
      this.querySelector('[data-screen="round-result"]').classList.remove('is-loss-result');
      this.querySelector('[data-round-result-icon]').textContent = '⚡';
      this.querySelector('[data-round-result-icon]').classList.remove('is-loss');
      const progressMascot = this.querySelector('[data-progress-mascot]');
      if (progressMascot) progressMascot.hidden = true;
      const lossMascot = this.querySelector('[data-loss-mascot]');
      if (lossMascot) lossMascot.hidden = true;
      const victoryMascot = this.querySelector('[data-victory-mascot]');
      if (victoryMascot) victoryMascot.hidden = true;
      this.querySelector('[data-round-result-icon]').hidden = false;
      this.querySelector('[data-round-result-title]').textContent = 'Remíza — nasleduje rozstrel';
      this.querySelector('[data-round-result-copy]').textContent = 'Rozhodne rýchla smrť. Otázky pokračujú dovtedy, kým sa jedna z vás nepomýli ako prvá.';
      this.updateRoundScoreline();
      this.querySelector('[data-continue-round-label]').textContent = 'Spustiť rozstrel';
      this.showScreen('round-result');
    }

    showSuddenDeathResult() {
      const copy = this.roundWon
        ? (this.round === 3
          ? `${this.currentOpponent.name} sa v rozstrele pomýlila ako prvá. Vyhrávaš turnaj.`
          : `${this.currentOpponent.name} sa v rozstrele pomýlila ako prvá. Postupuješ.`)
        : `V rozstrele si sa pomýlila ako prvá. ${this.currentOpponent.name} postupuje.`;
      this.tieBreakQuestionCursor += 1;
      this.showRoundResult(this.roundWon, copy);
    }

    showRoundResult(won, copy) {
      this.querySelector('[data-screen="round-result"]').classList.toggle('is-loss-result', !won);
      const resultIcon = this.querySelector('[data-round-result-icon]');
      resultIcon.textContent = won ? '✓' : '×';
      resultIcon.classList.toggle('is-loss', !won);
      resultIcon.hidden = true;
      this.querySelector('[data-round-result-title]').textContent = won ? (this.round === 3 ? 'Vyhrávaš turnaj!' : 'Postupuješ!') : 'Tentoraz nepostupuješ';
      this.querySelector('[data-round-result-copy]').textContent = copy;
      const progressMascot = this.querySelector('[data-progress-mascot]');
      if (progressMascot) progressMascot.hidden = !(won && this.round < 3);
      const lossMascot = this.querySelector('[data-loss-mascot]');
      if (lossMascot) lossMascot.hidden = won;
      const victoryMascot = this.querySelector('[data-victory-mascot]');
      if (victoryMascot) victoryMascot.hidden = !(won && this.round === 3);
      this.updateRoundScoreline();
      this.querySelector('[data-continue-round-label]').textContent = won && this.round < 3 ? 'Pokračovať' : 'Zobraziť môj výsledok';
      this.roundWon = won;
      this.roundAction = 'complete-round';
      this.showScreen('round-result');
    }

    updateRoundScoreline() {
      this.querySelector('[data-score-player-name]').textContent = this.playerName;
      this.querySelector('[data-score-opponent-name]').textContent = this.currentOpponent.name;
      this.querySelector('[data-round-player-score]').textContent = this.roundPlayerScore;
      this.querySelector('[data-round-opponent-score]').textContent = this.roundOpponentScore;
    }

    advanceAfterRound() {
      if (this.roundAction === 'start-sudden-death') {
        this.showQuestion(this.usedQuestions[this.tieBreakQuestionCursor]);
        return;
      }

      if (!this.roundWon) {
        this.players.find((player) => player.isUser).alive = false;
        this.showFinal(false);
        return;
      }

      this.currentOpponent.alive = false;
      this.simulateOtherEliminations();
      if (this.round === 3) {
        this.showFinal(true);
        return;
      }
      this.round += 1;
      this.showBracket(false);
    }

    simulateOtherEliminations() {
      const targetAlive = Math.max(1, 8 / (2 ** this.round));
      const bots = shuffle(this.getAlivePlayers().filter((player) => !player.isUser));
      while (this.getAlivePlayers().length > targetAlive && bots.length) {
        bots.pop().alive = false;
      }
    }

    showFinal(champion) {
      const placement = champion ? 1 : PLACEMENTS[this.round];
      this.querySelector('[data-placement]').textContent = `${placement}.`;
      this.querySelector('[data-final-title]').textContent = champion ? 'Šampiónka vedomostí' : 'Výborný výkon';
      this.querySelector('[data-final-copy]').textContent = champion
        ? `${this.playerName}, prešla si celým pavúkom a vyhrala si dnešnú Salabom arénu.`
        : `${this.playerName}, dostala si sa do kola ${ROUND_NAMES[this.round]}. Nabudúce môže byť trofej tvoja.`;
      this.querySelector('[data-total-correct]').textContent = `${this.totalCorrect} / ${this.totalAnswered}`;
      this.querySelector('[data-reached-round]').textContent = ROUND_NAMES[this.round];
      this.querySelector('.salabom-contest__confetti').hidden = !champion;
      this.showScreen('final');
    }

    resetGame() {
      this.nameInput.value = this.playerName;
      this.resetState();
      this.nameInput.focus();
    }

    escapeHtml(value) {
      return String(value)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
    }
  }

  customElements.define('salabom-knowledge-contest', SalabomKnowledgeContest);
})();
